import { useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AthleteSelect } from "@/components/AthleteSelect";
import { toast } from "sonner";

const P_LABEL = { present: "Presente", absent: "Assente", removed: "Rimosso" };
const errText = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : d?.message || "Errore"; };

export default function ParticipantsPanel({ session: s, athletes, groups, locked, onChange }) {
  const [add, setAdd] = useState("");
  const gName = (ids) => (ids || []).map((id) => groups.find((g) => g.id === id)?.name).filter(Boolean).join(", ") || "—";
  const current = (aid) => athletes.find((a) => a.id === aid);
  const progress = (aid) => s.test_ids.map((tid) => {
    const r = s.results.find((x) => x.test_id === tid && x.athlete_id === aid);
    return (r?.attempt_details || []).filter((a) => a.valid).length >= s.planned_attempts[tid] ? 1 : 0;
  }).reduce((a, b) => a + b, 0);

  const setStatus = async (aid, status) => {
    const hasRes = s.results.some((r) => r.athlete_id === aid);
    let reason = null;
    if (status !== "present" && hasRes) { reason = window.prompt("L'atleta ha risultati registrati (restano conservati). Motivo:"); if (!reason) return; }
    try { const { data } = await api.patch(`/test-sessions/${s.id}/participants/${aid}`, { status, reason }); onChange(data); } catch (e) { toast.error(errText(e)); }
  };
  const addOne = async () => {
    if (!add) return;
    try { const { data } = await api.post(`/test-sessions/${s.id}/participants`, { athlete_id: add, reason: "aggiunta manuale" }); onChange(data); setAdd(""); toast.success("Atleta aggiunto"); } catch (e) { toast.error(errText(e)); }
  };

  return (
    <div className="space-y-3" data-testid="participants-panel">
      {!locked && (
        <div className="flex items-end gap-2 max-w-xl">
          <div className="flex-1"><AthleteSelect value={add} onChange={setAdd} athletes={athletes.filter((a) => !s.participants.some((p) => p.athlete_id === a.id && p.status !== "removed"))} testid="participant-add-select" placeholder="Aggiungi atleta…" /></div>
          <Button data-testid="participant-add-btn" onClick={addOne} variant="outline" className="text-zinc-900">Aggiungi</Button>
        </div>
      )}
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[10px] uppercase tracking-wider text-zinc-500 bg-zinc-50">
            <tr><th className="text-left px-3 py-2">Atleta (snapshot)</th><th className="text-left px-3 py-2">Gruppi alla creazione</th><th className="text-left px-3 py-2">Gruppi attuali</th><th className="text-left px-3 py-2">Origine</th><th className="text-left px-3 py-2">Test completi</th><th className="text-left px-3 py-2">Stato</th></tr>
          </thead>
          <tbody>
            {s.participants.map((p) => {
              const cur = current(p.athlete_id);
              const moved = cur && JSON.stringify([...(cur.group_ids || [])].sort()) !== JSON.stringify([...(p.group_ids || [])].sort());
              return (
                <tr key={p.athlete_id} className="border-t border-zinc-100" data-testid={`participant-${p.athlete_id}`}>
                  <td className="px-3 py-2">{p.last_name} {p.first_name}{p.reason ? <div className="text-[10px] text-zinc-500">{p.reason}</div> : null}</td>
                  <td className="px-3 py-2 text-xs">{gName(p.group_ids)}</td>
                  <td className="px-3 py-2 text-xs">{cur ? gName(cur.group_ids) : "atleta archiviato"}{moved && <span data-testid={`participant-moved-${p.athlete_id}`} className="ml-1 text-[10px] px-1 rounded bg-blue-50 text-blue-800">cambio gruppo</span>}</td>
                  <td className="px-3 py-2 text-xs">{p.added === "group" ? "dal gruppo" : "manuale"}</td>
                  <td className="px-3 py-2 font-mono text-xs" data-testid={`participant-progress-${p.athlete_id}`}>{progress(p.athlete_id)}/{s.test_ids.length}</td>
                  <td className="px-3 py-2">
                    <select data-testid={`participant-status-${p.athlete_id}`} disabled={locked} className="h-9 border border-zinc-200 rounded text-xs px-1" value={p.status} onChange={(e) => setStatus(p.athlete_id, e.target.value)}>
                      {Object.entries(P_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
